import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import VesselTypeEditForm from '~/containers/vesselTypeEdit/vesselTypeEdit';
import VesselTypeArchive from '~/containers/vesselTypeArchive/vesselTypeArchive';

export class VesselTypeEditPage extends Component {
  state = {
    vesselType: null
  };

  onReceiveVesselType = ({ vesselType }) => {
    this.setState({
      vesselType
    });
  };

  render() {
    const vesselTypeId = this.props.match.params.vesselTypeId;
    const { vesselType } = this.state;

    const editButton = (
      <div className="flex">
        <VesselTypeArchive className="mr4" vesselType={vesselType} />
        <Link to={`/settings/vesseltypes/${vesselTypeId}`}>
          <Button color="secondary">Cancel</Button>
        </Link>
      </div>
    );

    return (
      <Page>
        <TitleBar
          back={`/settings/vesseltypes/${vesselTypeId}`}
          backText="Vessel type"
          title={vesselType ? vesselType.name : '...'}
          button={editButton}
        />
        <VesselTypeEditForm onCompleted={this.onReceiveVesselType} id={vesselTypeId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(VesselTypeEditPage));



// WEBPACK FOOTER //
// ./src/pages/vesselTypeEdit/vesselTypeEdit.jsx